module.exports = __webpack_public_path__ + "img/borders6.d2c696a5.png";